import React from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Link from 'gatsby-link'
import withStyles from '@material-ui/core/styles/withStyles'

const styles = (theme) => ({
  workoutBox: {
    width: 250,
    height: '100%',
    position: 'relative',
    paddingBottom: 10,
    [theme.breakpoints.down('sm')]: {
      width: 195,
      padding: 8,
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      maxWidth: 220,
      margin: 'auto',
    },
  },
  workoutIconWrapper: {
    height: '30%',
    marginTop: 15,
    [theme.breakpoints.down('xs')]: {
      marginTop: 10,
    },
  },
  workoutIcon: {
    width: 70,
    height: 70,
    display: 'block',
    fill: '#fff',
    margin: '0 auto 10px',
    [theme.breakpoints.down('sm')]: {
      width: 60,
      height: 60,
    },
    [theme.breakpoints.down('xs')]: {
      width: 50,
      height: 50,
    },
  },
  workoutName: {
    color: '#fff',
    fontWeight: 500,
    textAlign: 'center',
    height: '15%',
    padding: 10,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.2em',
      height: '13%',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.9em',
      height: '15%',
      padding: 5,
    },
  },
  workoutMentionCount: {
    color: 'yellow',
    fontWeight: 500,
  },
  workoutDescription: {
    color: theme.palette.text.lighter,
    textAlign: 'center',
    fontSize: '0.8em',
    height: 80,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.65em',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.65em',
      height: 65,
    },
  },
  readMore: {
    margin: 'auto',
    display: 'block',
    color: '#fff',
    width: '100%',
    transition: 'background 0.7s, color 0.7s',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.7em',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.7em',
    },
    '&:hover': {
      background: theme.palette.background.light,
      color: theme.palette.primary.main,
    },
  },
})

class WorkoutBox extends React.Component {
  extractPaletteColor = (colorPath) => {
    const dotReg = /\./
    const palette = colorPath.slice(0, colorPath.search(dotReg))
    const paletteColor = colorPath.slice(colorPath.search(dotReg) + 1)
    return {
      palette,
      paletteColor,
    }
  }
  render() {
    const {
      classes,
      theme,
      name,
      to,
      Icon,
      description,
      color,
      mentions,
    } = this.props
    const { palette, paletteColor } = this.extractPaletteColor(color)
    return (
      <div
        className={classes.workoutBox}
        style={{ background: theme.palette[palette][paletteColor] }}
      >
        <div className={classes.workoutIconWrapper}>
          <Icon className={classes.workoutIcon} alt={name} title={name} />
        </div>
        <Typography variant="headline" className={classes.workoutName}>
          {name}
        </Typography>
        <Typography align="center" style={{ color: '#fff', paddingTop: 2 }}>
          Mentioned{' '}
          <span className={classes.workoutMentionCount}>{mentions.length}</span>{' '}
          times
        </Typography>
        <Typography className={classes.workoutDescription}>
          {description}
        </Typography>
        <Link to={to}>
          <Button
            size="small"
            className={classes.readMore}
            style={{ background: paletteColor }}
          >
            Read More
          </Button>
        </Link>
      </div>
    )
  }
}

WorkoutBox.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  Icon: PropTypes.func.isRequired,
  description: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  mentions: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default withStyles(styles, { withTheme: true })(WorkoutBox)



// WEBPACK FOOTER //
// ./src/components/Frontpage/WorkoutBox.js